export const EDIT_SALES_CHANNEL_ACTION = 'Edit Sales Channel';
export const DELETE_SALES_CHANNEL_ACTION = 'Delete Sales Channel';
